


import axios from 'axios';
import { message } from 'antd';
import { local } from 'brownies';

message.config({
  duration: 1.5,
});

let url = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_VERSION}`
const http = axios.create({
  baseURL: url,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

http.interceptors.request.use(
  (config) => {
    let token = local.access_token
    if (token) {
      config.headers['Authorization'] = `Bearer ${ token }`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
/**
* response handler
* Mostly intended to handle 401 error
*/

message.loading({content: 'Loading...'})
http.interceptors.response
  .use(function (response) {
    if(response.status===200){
      if(typeof response.data.message !== 'undefined')
        message.success({content: response.data.message})
    }
    return response;
  }, function (error) {
  if(error.response.status===403){
    const msg = error.response.data ? error.response.data.message : "Unauthorised access level";
    message.error({content: msg})
  }
  else if(error.response.status===401){
    local.access_token = null;
    local.isAuthenticate = null;
    let url  = error.response.config.url.split('/')
    if(url[url.length-1] !== 'check'){
      message.error({content: 'Oops..! Session has expired!'})
    }
  }
  else if(error.response.status === 404){
    message.error({content: 'The requested api is not found in server. 404 error!'})
  }
  else if(error.response.status === 500){
    let ermgs = error.response.data ? error.response.data.message : '500 internal error!';
    message.error({content: ermgs})
  }
  return Promise.reject(error);
});
export default http;
